import { Leaderboard } from '../../Leaderboard Components/Leaderboard';
import { useTBContext } from '../../../Contexts/useTBStates';

interface LeaderboardPanelProps {
    appDims: any;
    compHeights: any;
}

export const LeaderboardPanel = ({ compHeights }: LeaderboardPanelProps) => {
    const { factor } = useTBContext();
    return <Leaderboard key={factor} factor={factor} compHeights={compHeights} />;
};
